import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { EntityTypeEnum } from '@/graphql/contracts/_generated_/contracts';
import {
  GetHistoryAudit,
  GetHistoryAuditVariables,
} from '@/graphql/contracts/_generated_/getHistoryAudit.query';
import GetHistoryAuditQuery from '@/graphql/contracts/getHistoryAudit.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export function useGetBundlesHistory() {
  const [_getBundlesHistory, { data, loading }] = useLazyQuery<
  GetHistoryAudit,
  GetHistoryAuditVariables
  >(GetHistoryAuditQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) => {
      notificationService.open({ title: 'Error', text: err.message, type: 'danger', });
    },
  });

  const getBundlesHistory = (bundleId: string) => {
    _getBundlesHistory({
      variables: {
        entityId: bundleId,
        entityType: EntityTypeEnum.BUNDLE,
      },
    });
  };

  return {
    getBundlesHistory,
    bundlesHistory: data?.history,
    isLoading: loading,
  };
}
